import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoiceListLayer from "../components/InvoiceListLayer";
import { API_URL, LOCATION_ID } from "..";
import { Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom"; // ✅ useLocation

const InvoiceListStatusPage = () => {
  const { status } = useParams();
  const location = useLocation(); // ✅ access query params

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  // ✅ Extract fromDate & toDate from query string
  const queryParams = new URLSearchParams(location.search);
  const fromDate = queryParams.get("fromDate");
  const toDate = queryParams.get("toDate");

  const fetchInvoices = async () => {
    setLoading(true);
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      window.location.href = "/sign-in";
      return;
    }

    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let url;
    if (user?.roles?.role === "admin") {
      url = `${API_URL}/api/invoice/dashboard/${status}?locationId=${LOCATION_ID}`;
    } else {
      url = `${API_URL}/api/invoice/get/user/${status}/${user?.id}?locationId=${LOCATION_ID}`;
    }

    // ✅ Append query params only if dates exist
    if (fromDate && toDate) {
      url += `&fromDate=${fromDate}&toDate=${toDate}`;
    }
    console.log(url)
    let response = await fetch(url, {
      method: "GET",
      headers: headersList,
    });
    const result = await response.json();
    setLoading(false);

    setData(result.invoices || []); // ✅ safe fallback
  };

  useEffect(() => {
    fetchInvoices();
  }, [status, fromDate, toDate]); // ✅ re-fetch when status or dates change

  return (
    <MasterLayout>
      <Breadcrumb title="Invoices" />

      {loading && (
        <div className="text-center mt-4">
          <Spinner />
        </div>
      )}

      {data.length > 0 && <InvoiceListLayer jobsData={data} />}
    </MasterLayout>
  );
};

export default InvoiceListStatusPage;
